const PROMPTS_EN = [
  [
    "Help me resolve a team conflict",
    "Show me how to give better feedback",
    "Help me set boundaries with a colleague",
    "I want to improve how I communicate at work",
    "I want to build stronger trust in my team",
    "Help me navigate office politics",
    "Show me how to deal with a difficult colleague",
    "I want to improve my presentation skills",
    "Help me communicate more clearly in meetings",
    "I need help giving constructive criticism"
  ], [
    "Help me manage a tough conversation",
    "I want to support a struggling teammate",
    "Help me delegate more effectively",
    "I want to become a more inspiring leader",
    "Show me how to lead through change",
    "Help me run better team check-ins",
    "I’m new to managing—where should I start?",
    "How do I give feedback to a senior team member?",
  ], [
    "Help me set priorities for the week",
    "Show me how to stop procrastinating",
    "I want to build a daily focus habit",
    "Help me create a meeting agenda",
    "Help me beat decision fatigue",
    "Show me how to plan a focused workday",
    "I want to reduce distractions at work",
    "Help me set up a weekly review routine",
    "I need help breaking down a complex project",
    "I want to protect my time from too many meetings",
  ], [
    "I want to prepare for a promotion",
    "I want to increase my visibility at work",
    "What skills should I focus on this year?",
    "Help me build a personal development plan",
    "I want to switch roles — where do I begin?",
    "Help me grow in my current position",
    "How do I make the most of my 1:1s with my manager?",
  ], [
    "I want to reflect on a recent failure",
    "Help me prepare for a performance review",
    "Help me turn feedback into action",
    "Help me process feedback I don’t agree with",
    "I want to learn from my last big mistake",
    "Show me how to ask for better feedback",
    "Help me reflect on my progress this quarter",
    "I want to prepare feedback for my manager",
  ], [
    "Help me manage stress at work",
    "I want to prevent burnout",
    "Show me how to balance work and life",
    "Help me stay calm under pressure",
    "I want to build more emotional resilience",
    "Show me how to create healthy work habits",
    "Help me recover after a stressful week",
    "I want to set better work-life boundaries",
    "Help me build a self-care routine that fits work",
    "I want to stop overcommitting myself",
  ], [
    "Show me how to work across time zones",
    "Help me make virtual meetings better",
    "I want to stay motivated working from home",
    "I want to feel more connected to my remote team",
    "Help me set communication norms with my team",
    "Show me how to collaborate async",
    "I want to avoid Zoom fatigue",
    "Help me manage hybrid team dynamics"
  ]
]

const PROMPTS_SV = [
  [
    "Hjälp mig lösa en konflikt i teamet",
    "Visa mig hur jag kan ge bättre feedback",
    "Hjälp mig sätta gränser med en kollega",
    "Jag vill bli bättre på att kommunicera på jobbet",
    "Jag vill bygga starkare förtroende i mitt team",
    "Hjälp mig navigera kontorspolitik",
    "Visa mig hur jag hanterar en svår kollega",
    "Jag vill förbättra mina presentationsfärdigheter",
    "Hjälp mig kommunicera tydligare på möten",
    "Jag behöver hjälp med att ge konstruktiv kritik"
  ], [
    "Hjälp mig hantera ett svårt samtal",
    "Jag vill stötta en kollega som kämpar",
    "Hjälp mig delegera mer effektivt",
    "Jag vill bli en mer inspirerande ledare",
    "Visa mig hur jag leder genom förändring",
    "Hjälp mig hålla bättre teammöten",
    "Jag är ny som chef – var ska jag börja?",
    "Hur ger jag feedback till en mer senior teammedlem?",
  ], [
    "Hjälp mig sätta prioriteringar för veckan",
    "Visa mig hur jag slutar skjuta upp saker",
    "Jag vill bygga en daglig fokusvana",
    "Hjälp mig skapa en mötesagenda",
    "Hjälp mig hantera beslutsutmattning",
    "Visa mig hur jag planerar en fokuserad arbetsdag",
    "Jag vill minska distraktioner på jobbet",
    "Hjälp mig sätta upp en veckogenomgång",
    "Jag behöver hjälp med att bryta ner ett komplext projekt",
    "Jag vill skydda min tid från för många möten",
  ], [
    "Jag vill förbereda mig för en befordran",
    "Jag vill öka min synlighet på jobbet",
    "Vilka färdigheter bör jag fokusera på i år?",
    "Hjälp mig skapa en personlig utvecklingsplan",
    "Jag vill byta roll – var börjar jag?",
    "Hjälp mig växa i min nuvarande roll",
    "Hur får jag ut mest av mina 1:1:or med min chef?",
  ], [
    "Jag vill reflektera över ett nyligt misslyckande",
    "Hjälp mig förbereda mig för ett utvecklingssamtal",
    "Hjälp mig omvandla feedback till handling",
    "Hjälp mig bearbeta feedback jag inte håller med om",
    "Jag vill lära mig av mitt senaste stora misstag",
    "Visa mig hur jag ber om bättre feedback",
    "Hjälp mig reflektera över mina framsteg det här kvartalet",
    "Jag vill förbereda feedback till min chef",
  ], [
    "Hjälp mig hantera stress på jobbet",
    "Jag vill förebygga utbrändhet",
    "Visa mig hur jag balanserar arbete och fritid",
    "Hjälp mig hålla mig lugn under press",
    "Jag vill bygga mer känslomässig resiliens",
    "Visa mig hur jag skapar hälsosamma arbetsvanor",
    "Hjälp mig återhämta mig efter en stressig vecka",
    "Jag vill sätta bättre gränser mellan jobb och privatliv",
    "Hjälp mig skapa en självvårdsrutin som passar jobbet",
    "Jag vill sluta ta på mig för mycket",
  ], [
    "Visa mig hur jag jobbar över tidszoner",
    "Hjälp mig göra virtuella möten bättre",
    "Jag vill hålla motivationen uppe när jag jobbar hemifrån",
    "Jag vill känna mig mer uppkopplad till mitt distansteam",
    "Hjälp mig sätta kommunikationsnormer i teamet",
    "Visa mig hur jag samarbetar asynkront",
    "Jag vill undvika Zoom-trötthet",
    "Hjälp mig hantera dynamiken i ett hybridteam"
  ]
]

export const getPrompts = (nr: number, lang: string) => {
  let prompts: Array<Array<string>>;
  if (lang === 'sv') {
    prompts = PROMPTS_SV
  } else {
    prompts = PROMPTS_EN
  }

  const promptCategories = prompts.length

  const categories: Array<number> = []
  const suggestions = []

  while (categories.length < nr) {
    const category = Math.floor(Math.random() * (promptCategories - 1))
    if (categories.indexOf(category) === -1) {
      categories.push(category)
    }
  }

  for (const category of categories) {
    const rows = prompts[category].length
    const promptNr = Math.floor(Math.random() * (rows - 1))
    suggestions.push(prompts[category][promptNr])
  }

  return suggestions
}

export interface AiThreadStart {
  aiStyle: string;
  type: string;
  focusAreaId: string|null;
  taskId: string|null;
  threadId: string|null;
  message: string|null;
  originName?: string|null;
  originId?: string|null;
  systemMessage?: string|null;
  date: string;
}

export function loadAiStart() {
  const aiThreadStartString = localStorage.getItem('ai_thread_start')
  if (!aiThreadStartString) {
    return null
  }
  localStorage.removeItem('ai_thread_start')
  const aiThreadStart: AiThreadStart = JSON.parse(aiThreadStartString);
  const now = new Date()
  const startDate = new Date(aiThreadStart.date)
  if (now.getSeconds() - startDate.getSeconds() > 5) {
    console.log('aiThreadStart is too old: ' + startDate)
    return null
  }
  return aiThreadStart;
}

export function storeAiStart(aiStyle: string, type: string, focusAreaId: string|null = null, taskId: string|null = null,
                             threadId: string|null = null, message: string|null = null, originName: string|null = null,
                             originId: string|null = null, systemMessage: string|null = null) {
  const aiThreadStart: AiThreadStart = {
    aiStyle: aiStyle,
    type: type,
    focusAreaId: focusAreaId,
    taskId: taskId,
    threadId: threadId,
    message: message,
    originId: originId,
    originName: originName,
    systemMessage: systemMessage,
    date: new Date().toISOString()
  }
  localStorage['ai_thread_start'] = JSON.stringify(aiThreadStart)
}